import React from 'react';
import SubscriptionPage from '../Subscription/SubscriptionPage';
import './subscriptionWrapper.scss';

const SubscriptionWrapper: React.FC = () => {
  return (
    <div className="subscription-wrapper">
      <SubscriptionPage />
    </div>
  );
};

export default SubscriptionWrapper;